module.exports = __webpack_public_path__ + "static/media/25.1a5161f5.jpg";